"use strict";
var BLEEddystoneURL_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLEEddystoneURLBuilder = exports.BLEEddystoneURL = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@openhps/core");
const BLEEddystone_1 = require("./BLEEddystone");
const BLEUUID_1 = require("./BLEUUID");
const BLEBeaconObject_1 = require("./BLEBeaconObject");
const BLEService_1 = require("./BLEService");
const ts_md5_1 = require("ts-md5");
let BLEEddystoneURL = BLEEddystoneURL_1 = class BLEEddystoneURL extends BLEEddystone_1.BLEEddystone {
    isValid() {
        return super.isValid() && this.frame === 0x10 && this.url !== undefined;
    }
    computeUID() {
        return this.address ? this.address.toString() : ts_md5_1.Md5.hashStr(this.url);
    }
    parseServiceData(uuid, serviceData) {
        super.parseServiceData(uuid, serviceData);
        if (uuid === undefined && serviceData === undefined) {
            return this;
        }
        if (!this.service) {
            return this;
        }
        if (this.frame !== 0x10) {
            return this; // Do not attempt to parse
        }
        const urlData = new Uint8Array(serviceData.slice(2, serviceData.byteLength));
        const view = new DataView(urlData.buffer, 0);
        if (view.buffer.byteLength === 0) {
            return this;
        }
        const prefix = view.getUint8(0);
        if (prefix > BLEEddystoneURL_1.PREFIXES.length) {
            return this;
        }
        this.url = BLEEddystoneURL_1.PREFIXES[prefix];
        for (let i = 1; i < view.byteLength; i++) {
            this.url +=
                view.getUint8(i) < BLEEddystoneURL_1.SUFFIXES.length
                    ? BLEEddystoneURL_1.SUFFIXES[view.getUint8(i)]
                    : String.fromCharCode(view.getUint8(i));
        }
        if (this.uid === undefined) {
            this.uid = this.computeUID();
        }
        return this;
    }
};
exports.BLEEddystoneURL = BLEEddystoneURL;
BLEEddystoneURL.PREFIXES = ['http://www.', 'https://www.', 'http://', 'https://', 'urn:uuid:'];
BLEEddystoneURL.SUFFIXES = [
    '.com/',
    '.org/',
    '.edu/',
    '.net/',
    '.info/',
    '.biz/',
    '.gov/',
    '.com',
    '.org',
    '.edu',
    '.net',
    '.info',
    '.biz',
    '.gov',
];
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", String)
], BLEEddystoneURL.prototype, "url", void 0);
exports.BLEEddystoneURL = BLEEddystoneURL = BLEEddystoneURL_1 = tslib_1.__decorate([
    (0, core_1.SerializableObject)()
], BLEEddystoneURL);
/**
 * BLE Eddystone URL builder
 */
class BLEEddystoneURLBuilder extends BLEBeaconObject_1.BLEBeaconBuilder {
    constructor() {
        super();
        this.beacon = new BLEEddystoneURL();
        this.beacon.frame = 0x10;
        this.beacon.url = '';
    }
    static create() {
        return new BLEEddystoneURLBuilder();
    }
    static fromBeacon(beacon) {
        const builder = new BLEEddystoneURLBuilder();
        builder.beacon = beacon;
        return builder;
    }
    url(url) {
        this.beacon.url = url;
        return this;
    }
    calibratedRSSI(rssi) {
        this.beacon.calibratedRSSI = rssi;
        return this;
    }
    getEncodedURL() {
        const view = new DataView(new ArrayBuffer(17), 0);
        let index = 0;
        let url_index = 0;
        const url = this.beacon.url;
        BLEEddystoneURL.PREFIXES.forEach((prefix) => {
            if (url.toLowerCase().startsWith(prefix)) {
                // Encode using this prefix
                view.setUint8(index, BLEEddystoneURL.PREFIXES.indexOf(prefix));
                url_index += prefix.length;
            }
        });
        index += 1;
        for (let i = url_index; i < url.length; i++) {
            if (index > 17) {
                break;
            }
            view.setUint8(index, url.charCodeAt(i));
            BLEEddystoneURL.SUFFIXES.forEach((suffix) => {
                if (url.slice(i).toLowerCase().startsWith(suffix)) {
                    view.setUint8(index, BLEEddystoneURL.SUFFIXES.indexOf(suffix));
                    i += suffix.length - 1;
                }
            });
            index++;
        }
        return { url: view, length: index };
    }
    build() {
        return new Promise((resolve) => {
            // Eddystone Service
            const { url, length } = this.getEncodedURL();
            const serviceData = new DataView(new ArrayBuffer(19 - (17 - length)), 0);
            serviceData.setUint8(0, 0x10); // Eddystone-URL frame
            serviceData.setInt8(1, this.beacon.getCalibratedRSSI(0, core_1.LengthUnit.METER));
            // Encoded URL
            for (let i = 0; i < length; i++) {
                serviceData.setUint8(2 + i, url.getUint8(i));
            }
            this.beacon.addService(new BLEService_1.BLEService(BLEUUID_1.BLEUUID.fromString('FEAA'), new Uint8Array(serviceData.buffer)));
            this.beacon.uid = this.beacon.computeUID();
            resolve(this.beacon);
        });
    }
}
exports.BLEEddystoneURLBuilder = BLEEddystoneURLBuilder;
//# sourceMappingURL=BLEEddystoneURL.js.map